module.exports = __webpack_public_path__ + "./assets/img_ximen_grey@2x__43b86b23964dd36f8f5470d2c8957e2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_ximen_grey@2x.jpg
// module id = 620
// module chunks = 12